package horcrux.common.types

import kotlinx.serialization.Serializable

@Serializable
data class TruncatedString(val content: String, private val displayLength: Int = 10) : CharSequence by content {
    override fun toString(): String = content.take(displayLength)
}
